import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-active-recruiters',
  templateUrl: './active-recruiters.component.html',
  styleUrls: ['./active-recruiters.component.scss']
})
export class ActiveRecruitersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
